import { FC } from 'react';
import { Disclosure } from '@headlessui/react';
import { ChevronDownIcon, PlusIcon, MinusIcon } from '@heroicons/react/24/outline';
import useClassNames from '@loomstateorg/shared-frontend/hooks/useClassNames';
import { AccordionProps } from '.';
import Typography from '@loomstateorg/shared-frontend/components/commercetools-ui/atoms/typography';

type AccordionButtonProps = AccordionProps & {
  open: boolean;
  buttonWrapperClassName?: string;
  buttonClassName?: string;
};

const AccordionButton: FC<AccordionButtonProps> = ({
  open,
  buttonWrapperClassName,
  buttonClassName,
  openSectionTitle,
  closedSectionTitle,
  collapsedLabel,
  variant,
  iconClassName,
  'data-testid': dataTestId = 'atom-accordion-button',
}) => {
  const buttonClassNames = useClassNames(['w-full flex justify-between', buttonClassName]);

  return (
    <Disclosure.Button className={`${buttonWrapperClassName} w-full`} data-testid={dataTestId}>
      <div className={buttonClassNames}>
        <Typography className="self-center transition" fontSize={16}>
          {open ? openSectionTitle : closedSectionTitle}
        </Typography>
        <div className="flex items-center gap-8">
          {!open && collapsedLabel && <p className="font-medium text-primary-regular">{collapsedLabel}</p>}
          {variant === 'arrow' ? (
            <ChevronDownIcon
              width={17.5}
              strokeWidth={1}
              className={`${open ? 'rotate-180' : ''} ${iconClassName} transition`}
            />
          ) : !open ? (
            <PlusIcon width={17.5} strokeWidth={2} className={iconClassName} />
          ) : (
            <MinusIcon width={17.5} strokeWidth={2} className={iconClassName} />
          )}
        </div>
      </div>
    </Disclosure.Button>
  );
};

export default AccordionButton;
